import { Text } from '@savvy-kit/foundations/text';
import { isNil } from 'es-toolkit';
import { UsersRound } from 'lucide-react';
import { graphql } from 'src/gql';

import { useAuth } from '@savvy/deprecated-shared/hooks/use-auth';
import { advisorLoginAsBannerColor } from '@savvy/deprecated-shared/theme';
import { useQueryWithErrorLogging } from '@savvy/graphql-hooks/useQueryWithErrorLogging';

import { LogoutAsButton } from '../logout-as-button';

const CLIENT_QUERY = graphql(/* GraphQL */ `
  query ClientFromDashboardAdvisorImpersonationBar($id: ID!) {
    client(id: $id) {
      user {
        id
        firstName
        lastName
        email
        profilePicUrl
      }
      household {
        name
        salesforceAccountId
      }
    }
  }
`);

export function AdvisorImpersonationBar() {
  const { user } = useAuth();
  const { data } = useQueryWithErrorLogging(CLIENT_QUERY, {
    variables: {
      id: user?.id ?? '',
    },
    skip: isNil(user?.id),
  });
  const client = data?.client;

  const clientName = `${client?.user.firstName} ${client?.user.lastName}`;
  return (
    <header
      className="fixed top-0 right-0 left-0 z-[999999] flex w-full flex-col shadow-[0px_1px_5px_rgba(100,116,139,0.12)]"
      style={{ backgroundColor: advisorLoginAsBannerColor }}
    >
      {client && (
        <div className="flex h-16 flex-row items-center justify-between gap-2">
          <div className="ml-4 flex min-w-0 flex-row items-center sm:ml-6">
            <UsersRound className="shrink-0 text-[var(--savvy-neutral-500)]" />
            <Text variant="subtitle-lg" color="secondary" className="ml-2 min-w-0 truncate">
              {`Logged in as ${clientName}`}
            </Text>
            <Text variant="body-sm" color="secondary" className="ml-2 hidden min-w-0 truncate sm:block">
              {`Changes will be visible to ${client.household.name.replace('Household', '')}`}
            </Text>
          </div>
          <LogoutAsButton
            destinationUrl={`/advisor/dashboard/client/${client.household.salesforceAccountId}`}
            className="mr-4 min-h-11 shrink-0 sm:mr-8 sm:min-h-0"
            compactOnSmallScreens
          />
        </div>
      )}
    </header>
  );
}
